import { differenceInHours } from 'date-fns';

import { CommunicationMethodMagicLink } from '@pflegia/types/common/enums/communication-method-magic-link.enum';
import { INVITE_SOURCE_BY_COMMUNICATION_METHOD, InviteOpenAcceptSource } from '@pflegia/types/common/enums/invite-open-accept-source.enum';
import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';
import { INVITE_OFFER_COOKIE } from '@pflegia/util/common/storage/invite-offer-cookies';

import { INVITE_OPEN_SOURCE_EXPIRE_HOURS } from '../application/constants';

export const getInviteSource = (jobPositionId: string) => {
  const storedMatchId = cookieStorage.getItem(INVITE_OFFER_COOKIE.MatchId);
  const storedTime = cookieStorage.getItem(INVITE_OFFER_COOKIE.Time);
  const storedJobPositionId = cookieStorage.getItem(INVITE_OFFER_COOKIE.JobPositionId);
  const storedCommunicationMethod = cookieStorage.getItem(INVITE_OFFER_COOKIE.CommunicationMethod);

  return storedMatchId && storedTime && storedJobPositionId === jobPositionId
    ? getInviteSourceFromProps(new Date(storedTime), storedCommunicationMethod as CommunicationMethodMagicLink)
    : InviteOpenAcceptSource.SameSession;
};

const getInviteSourceFromProps = (storedDate: Date, communicationMethod?: CommunicationMethodMagicLink) => {
  if (differenceInHours(new Date(), storedDate) >= INVITE_OPEN_SOURCE_EXPIRE_HOURS) return InviteOpenAcceptSource.SameSession;

  return communicationMethod
    ? (INVITE_SOURCE_BY_COMMUNICATION_METHOD[communicationMethod] ?? InviteOpenAcceptSource.SameSession)
    : InviteOpenAcceptSource.SameSession;
};
